module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book wouldn’t have been possible without the close support and encouragement of my friends and family, in particular: Adrian Rodgers for giving me the encouragement to start writing, Rob Wittwer for all of his understanding over the years, and Nick Dexter for his help at the National Archives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks must also go to my sister Nicola, and her partner Dan, for all of their encouragement over the years, and to my mother Christine and late father George, to whom this book is dedicated, for their unconditional love.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c65c246","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Acknowledgements.vue
// module id = 69
// module chunks = 0